<template>
    <div class="scroll-container" ref="scrollContainer" @wheel.prevent="onWheel">
        <slot></slot>
    </div>

</template>

<script>

export default {
    name: "HorizontalScroll",
    methods: {
        onWheel(event) {
            const scrollContainer = this.$refs.scrollContainer;
            if (scrollContainer) {
                scrollContainer.scrollLeft += event.deltaY; // 將垂直滾動轉換為水平滾動
            }
        },
    }
}
</script>


<style scoped lang="less">
    .scroll-container {
        width: 100%;
        white-space: nowrap; /* 讓內容水平排列 */
        overflow-x: auto; /* 僅允許水平滾動 */
        overflow-y: hidden; /* 隱藏垂直滾動條 */
        min-width: inherit;
        scroll-behavior: smooth; /* 平滑滾動 */
    }
</style>
